import { render } from "./homeView.vue?vue&type=template&id=672e8ac0&ts=true"
import script from "./homeView.vue?vue&type=script&lang=ts"
export * from "./homeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__